'use client';
import { Flex, Box, omitText, Typography, CartBadge } from '@kohler-dsm-library/kohler-core';
import { UserIcon, FavoriteNavFilledIcon, FavoriteNavIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { LocationPickButton } from './subcomponents/LocationPickButton/LocationPickButton.mjs';
import { LanguagePicker } from './subcomponents/LanguagePicker/LanguagePicker.mjs';
import classes from './UtilityLinks.module.css.mjs';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false, ...omitFavoritesCTA2 } = favoritesCTA;
  return { isFilled, omitFavoritesCTA: omitFavoritesCTA2 };
};
const UtilityLinks = ({
  isLoggedIn = false,
  locationPickerCTA,
  languagePicker,
  favoritesCTA,
  cartBadgeCTA,
  userName,
  userCTA,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  utilityLinksMobile,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  userCTAMobile,
  menuType,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.utilityLinks, className), ...rest }, (locationPickerCTA || languagePicker) && /* @__PURE__ */ React.createElement(Flex, { align: "center", gap: 25, paddingLeft: 25 }, locationPickerCTA && /* @__PURE__ */ React.createElement(LocationPickButton, { "aria-expanded": menuType === "store", ...locationPickerCTA }), languagePicker && /* @__PURE__ */ React.createElement(
    LanguagePicker,
    {
      ...languagePicker,
      languagePickerCTA: {
        "aria-expanded": menuType === "language",
        ...languagePicker.languagePickerCTA
      }
    }
  )), (locationPickerCTA || languagePicker) && /* @__PURE__ */ React.createElement("div", { className: classes.divider }), /* @__PURE__ */ React.createElement(Flex, { className: classes.utilityLink, gap: 15, align: "center" }, userCTA && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      display: "flex",
      textColor: "var(--content-primary)",
      "aria-label": isLoggedIn ? "user sign in" : "profile",
      "aria-expanded": menuType === "user",
      ...omitText(userCTA)
    },
    isLoggedIn && userName ? /* @__PURE__ */ React.createElement(Typography, { size: "label-medium-xs", textColor: "var(--content-primary)" }, "Hi, ", userName) : /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: false })
  ), favoritesCTA && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "a",
      display: "flex",
      "aria-label": "see favorites",
      textColor: "var(--content-primary)",
      ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
    },
    omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ React.createElement(FavoriteNavFilledIcon, { withBoundingBox: false }) : /* @__PURE__ */ React.createElement(FavoriteNavIcon, { withBoundingBox: false })
  ), cartBadgeCTA && /* @__PURE__ */ React.createElement(CartBadge, { display: "flex", textColor: "var(--content-primary)", component: "a", "aria-label": "see cart", ...cartBadgeCTA })));
};

export { UtilityLinks };
